export default __webpack_public_path__ + "static/media/team-mosaic-03.a7c30b93.jpg";